import { useState, useEffect } from 'react';
import { EVENT_TYPES } from '../constants';
export const useGeoLocation = () => {
    const [geo, setGeo] = useState({});
    useEffect(() => {
        const handleGeoUpdated = () => {
            setGeo(window.STATE?.geo || {});
        };
        // Listen for the custom event
        window.addEventListener(EVENT_TYPES.GEO_UPDATED, handleGeoUpdated);
        // Initial check
        handleGeoUpdated();
        return () => {
            window.removeEventListener(EVENT_TYPES.GEO_UPDATED, handleGeoUpdated);
        };
    }, []);
    return geo;
};
